import { css, cx } from '@emotion/css';
import { AlignItems, BaseStyle, Color, Display, JustifyContent, Spacing, TextAlign } from 'src/styles';

export const modifySignatureButton = cx(
  css`
    ${Spacing.mt8}
    ${Spacing.mb20}
    ${Display.flex}
    ${AlignItems.center}
    ${BaseStyle.clickable}
  `,
);

export const drawnSignatureContainer = cx(
  css`
    ${Display.flex}
    height: 40px;
    ${Spacing.mb20}
    ${AlignItems.center}
    ${Spacing.pl12}
  `,
);

export const fontSignatureContainer = css`
  ${Display.flex}
  height: 40px;
  ${Spacing.mb20}
  ${AlignItems.center}
  font-size: 24px;
  ${Spacing.pl12}
  ${BaseStyle.clickable}
`;

export const signatureContainer = css`
  height: 40px;
  width: 100%;
`;

export const signaturePadContainer = cx(
  css`
    border: 1px solid ${Color.Brand5};
    ${Display.flex}
    ${JustifyContent.center}
    ${AlignItems.center}
    cursor: crosshair;
    ${Spacing.mr8}
  `,
);

export const drawSignature = css`
  ${Display.flex}
  ${AlignItems.center}
  ${TextAlign.center}
  ${JustifyContent.center}
  ${Spacing.mb16}
`;

export const quillPen = css`
  font-size: 21px;
  ${Spacing.mr8}
  ${Spacing.mt4}
  color: ${Color.Brand6};
`;

export const penStyle = css`
  font-size: 17px;
  ${Spacing.mr8}
  color: ${Color.Brand6};
`;
